import type { PipeTransform } from '@angular/core';
import { ChangeDetectorRef, inject, Pipe } from '@angular/core';
import { type TranslateAbleText } from './translate-able-text';
import {
  TRANSLOCO_LANG,
  TRANSLOCO_SCOPE,
  TranslocoPipe,
  TranslocoService,
} from '@jsverse/transloco';
import { resolveTranslateAbleText } from './resolve-translate-able-text';
import { isString } from '@pct-ts/typeguard';

@Pipe({
  name: 'resolveTranslateAbleText',
  pure: false,
})
export class ResolveTranslateAbleTextPipe implements PipeTransform {
  readonly #translocoPipe = new TranslocoPipe(
    inject(TranslocoService),
    inject(TRANSLOCO_SCOPE, { optional: true }) ?? undefined,
    inject(TRANSLOCO_LANG, { optional: true }) ?? undefined,
    inject(ChangeDetectorRef),
  );

  transform(value: TranslateAbleText | null | undefined): string {
    const result = resolveTranslateAbleText(value);
    if (isString(result)) {
      return result;
    }

    return this.#translocoPipe.transform(result.key, result?.params ?? undefined);
  }
}
